module.exports = __webpack_public_path__ + "img/FM.bc881208.png";